import { apiClient } from '@/lib/api/client'
import type { Artwork, ArtworkStatus, Tag, User } from '@/types/entities'
import type { PaginationParams, PaginatedResponse } from '@/types/common'

export interface ArtworkSearchParams {
  keyword?: string
  artistId?: number
  status?: ArtworkStatus
  tagIds?: number[]
}

export interface ArtworkSearchResult extends Artwork {
  artist: {
    id: number
    firstName: string
    lastName: string
    artisticName?: string
    email: string
  }
}

export const adminApi = {
  searchArtworks: async (
    params: ArtworkSearchParams,
    pagination: PaginationParams
  ): Promise<PaginatedResponse<ArtworkSearchResult>> => {
    const queryParams: Record<string, string> = {
      start: String(pagination.start),
      limit: String(pagination.limit),
    }

    if (params.keyword) {
      queryParams.keyword = params.keyword
    }
    if (params.artistId) {
      queryParams.artistId = String(params.artistId)
    }
    if (params.status) {
      queryParams.status = params.status
    }
    if (params.tagIds && params.tagIds.length > 0) {
      queryParams.tagIds = params.tagIds.join(',')
    }

    const response = await apiClient.get<ArtworkSearchResult[] & { count?: number }>(
      '/api/admin/artworks/search',
      { params: queryParams }
    )

    const artworks = response.data
    return {
      data: artworks || [],
      total: artworks?.count || 0,
      start: pagination.start,
      limit: pagination.limit,
    }
  },

  getArtists: async (): Promise<User[]> => {
    const response = await apiClient.get<User[]>('/api/admin/artists')
    return response.data
  },

  getTags: async (): Promise<Tag[]> => {
    const response = await apiClient.get<Tag[]>('/api/admin/tags')
    return response.data
  },
}
